import { validate } from 'vue-convenia-util'

const isExternal = (link) => {
  const isExternal = validate.is(link, 'String') && /^https?:\/\//.test(link)
  return isExternal
}

export default isExternal



// WEBPACK FOOTER //
// ./src/helpers/isExternal.js